import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import {
  Header2,
  Headline4,
  ParagraphS,
} from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  ${defaultContainerSize};
  display: flex;
  flex-direction: column;

  ${mq.medium(css`
    padding-left: 3rem;
    padding-right: 3rem;
  `)};

  ${mq.large(css`
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  `)};

  ${mq.xLarge(css`
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  `)};
`;

export const Title = styled.h1`
  ${Header2};
  color: ${({ theme }) => theme.colors.core_black};
  margin: 4rem 0 2rem 0;

  ${mq.medium(css`
    font-size: 2.5rem;
    margin: 5rem 0 2rem 0;
  `)};

  ${mq.xLarge(css`
    font-size: 3rem;
    line-height: 3.5rem;
    margin: 7.5rem 0 4rem 0;
  `)};
`;

export const Reasons = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.core_black};
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 2rem;

  ${mq.medium(css`
    margin-bottom: 5rem;
  `)};

  ${mq.xLarge(css`
    flex-direction: row;
    margin-bottom: 8.75rem;
  `)};
`;

export const Reason = styled.div`
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;

  ${mq.xLarge(css`
    flex-direction: column;
    width: 17.6rem;
    justify-content: normal;
    margin-bottom: 2.5rem;
  `)};
`;

export const TextContainer = styled.div`
  margin-left: 1rem;

  ${mq.medium(css`
    margin-left: 1.5rem;
  `)};

  ${mq.xLarge(css`
    margin-left: 0;
  `)};
`;

export const ImageWrapper = styled.div`
  width: 4rem;
  height: 4rem;
`;

export const ReasonTitle = styled.p`
  ${Headline4};
  margin-top: 0;
  margin-bottom: 0.25rem;

  ${mq.medium(css`
    margin-bottom: 0.5rem;
  `)};

  ${mq.xLarge(css`
    margin-top: 2.5rem;
    margin-bottom: 1rem;
  `)};
`;

export const ReasonDescription = styled.p`
  ${ParagraphS};
  line-height: 1.5rem;
  letter-spacing: 0.013rem;
  margin: 0;

  ${mq.medium(css`
    line-height: 2rem;
  `)};
`;
